import { Tooltip } from "@mui/material";
import { Icon, Tag } from "pepsico-ds";

export const TABLE_CONFIG = {
  ROWS_PER_PAGE: 10,
  NO_DATA_LABEL: "No products available",
};

export const PRODUCT_HEADER_DATA = [
  {
    columnKey: "image",
    header: "IMAGE",
  },
  {
    columnKey: "name",
    header: "NAME",
  },
  {
    columnKey: "sku",
    header: "EAN/UPC",
  },
  {
    columnKey: "keywordGroups",
    header: "KEYWORD GROUPS",
  },
  {
    columnKey: "keywords",
    header: "KEYWORDS",
  },
  {
    columnKey: "productGroup",
    header: "PRODUCT GROUP",
  },
  {
    columnKey: "actions",
    header: "Actions",
    className: "text-center",
  },
];

export const PRODUCT_GROUP_HEADER_DATA = [
  {
    columnKey: "name",
    header: "Group Name",
  },
  {
    columnKey: "productCount",
    header: "Product Count",
  },
  {
    columnKey: "actions",
    header: "Actions",
    className: "text-center",
  },
];

export const renderKeywordGroups = (keywordGroupNames = []) => {
  if (!keywordGroupNames.length) return "-";
  const display = keywordGroupNames
    .slice(0, 2)
    .map((name) => (
      <Tag
        key={name}
        text={name}
        color="Blue-500"
        isCopyable={false}
        isRemovable={false}
        size="small"
        style={{ marginRight: 4 }}
      />
    ));
  if (keywordGroupNames.length <= 2) return <span>{display}</span>;
  return (
    <Tooltip title={keywordGroupNames.join(", ")} arrow placement="top">
      <span style={{ cursor: "pointer" }}>
        {display}
        <Tag
          text={`+${keywordGroupNames.length - 2}`}
          color="Gray-300"
          isCopyable={false}
          isRemovable={false}
          size="small"
        />
      </span>
    </Tooltip>
  );
};

export const renderKeywordsCount = (count) => {
  if (!count) return "-";
  return (
    <Tag
      text={count > 100 ? "100+" : String(count)}
      color="Blue-500"
      isCopyable={false}
      isRemovable={false}
      size="small"
    />
  );
};

export const STYLES = {
  actions: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
    justifyContent: "center",
  },
  editIcon: {
    cursor: "pointer",
    color: "#007bff",
    fontSize: "16px",
  },
  deleteIcon: {
    cursor: "pointer",
    color: "#dc3545",
    fontSize: "16px",
  },
  disabledIcon: {
    cursor: "not-allowed",
    color: "#6c757d",
    fontSize: "16px",
    opacity: 0.5,
  },
  viewIcon: {
    cursor: "pointer",
    color: "#17a2b8",
    fontSize: "16px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  },
  productImage: {
    width: 40,
    height: 40,
    objectFit: "cover",
    borderRadius: 4,
  },
};

export const MESSAGES = {
  LOADING: "Loading products...",
  EDIT_TOOLTIP: "Edit product",
  DELETE_TOOLTIP: "Delete product",
  DELETE_DISABLED_TOOLTIP: "Cannot delete - already deleted",
  VIEW_TOOLTIP: "View products in group",
};

export const TAG_COLORS = {
  ACTIVE: "Green-500",
  DELETED: "Red-500",
  GROUP: "Blue-500",
};

export const VIEW_OPTIONS = [
  { id: "products", displayText: "Individual products" },
  { id: "product-groups", displayText: "Product groups" },
];

export const createStatusTag = (deleted) => (
  <Tag
    text={deleted ? "Deleted" : "Active"}
    color={deleted ? TAG_COLORS.DELETED : TAG_COLORS.ACTIVE}
    isCopyable={false}
  />
);

export const createProductActionButtons = (product, onView, onEdit, onDelete) => (
  <div style={STYLES.actions}>
    <Icon
      icon="visibility"
      onClick={() => onView(product)}
      style={STYLES.viewIcon}
      title="View product"
    />
    <Icon
      icon="edit"
      onClick={() => onEdit(product)}
      style={STYLES.editIcon}
      title={MESSAGES.EDIT_TOOLTIP}
    />
    <Icon
      icon="delete"
      onClick={
        product.deleted ? undefined : () => onDelete(product.id, product.name)
      }
      style={product.deleted ? STYLES.disabledIcon : STYLES.deleteIcon}
      title={
        product.deleted ? MESSAGES.DELETE_DISABLED_TOOLTIP : MESSAGES.DELETE_TOOLTIP
      }
    />
  </div>
);

export const createGroupActionButtons = (
  group,
  onViewGroup,
  onEditGroup,
  onDeleteGroup
) => (
  <div style={STYLES.actions}>
    <Icon
      icon="visibility"
      onClick={() => onViewGroup(group)}
      style={STYLES.viewIcon}
      title={MESSAGES.VIEW_TOOLTIP}
    />
    <Icon
      icon="edit"
      onClick={() => onEditGroup(group)}
      style={STYLES.editIcon}
      title="Rename group"
    />
    <Icon
      icon="delete"
      onClick={() => onDeleteGroup(group)}
      style={STYLES.deleteIcon}
      title="Delete group"
    />
  </div>
);
